import { QRCodeSVG } from "qrcode.react";
import ScreenService from "./services/ScreenService";
import BackButton from "./assets/backButton.svg";
import GearButton from "./assets/gearButton.svg";
import { getModelConfig } from "./utils/models";
import SupportInfo from "./components/Activation/SupportInfo";
import SalesInfo from "./components/Activation/SalesInfo";
import SalesCard from "./components/Activation/SalesCard";
import SalesLogos from "./components/Activation/SalesLogos";
import BrandInfo from "./components/Activation/BrandInfo";
import { useActivationFlow } from "./hooks/useActivationFlow";
import "./ActivationScreen.scss";

const ActivationLanding = ({ setStep, config, handleKeyDown }) => {
    const { andMoreText, showButtonHelperText, onlyAvailableHelper, coBrandedLogo, salesCTAText, salesPhone } = config;

    return (
        <div className="activation">
            <div className="sales-screen-container">
                <div className="sales-container">
                    <div className="activation-cta-container">
                        <div className="activation-cta-copy">
                            <div className="copy-titles">
                                <div className="copy-title">Ready to start watching your</div>
                                <div className="copy-title">purchased packages?</div>
                            </div>
                            <div className="copy-subtitles">
                                <div className="qr-activation-subtitle">Stream NFL Sunday Ticket, Peacock Sports Pass,</div>
                                <div className="qr-activation-subtitle">{andMoreText}</div>
                            </div>
                            {showButtonHelperText && <div className="pre-button-copy"> Activate your subscription to unlock your EverPass streaming access</div>}
                        </div>
                        <button tabIndex={-1} autoFocus onKeyDown={(event) => handleKeyDown(event, 2)} onClick={() => setStep(2)} className="activate-button">
                            Activate Now
                        </button>
                        <div className="activation-cta-footer">
                            <SupportInfo />
                        </div>
                    </div>
                    <div className="separator"></div>
                    <div className="sales-info-container">
                        <SalesCard salesCTAText={salesCTAText} salesPhone={salesPhone} coBrandedLogo={coBrandedLogo} />
                        {onlyAvailableHelper && (
                            <div className="activation-cta-footer">
                                <div>{onlyAvailableHelper}</div>
                            </div>
                        )}
                    </div>
                </div>
                <div className="sales-container">
                    <SalesLogos coBrandedLogo={coBrandedLogo} />
                </div>
            </div>
        </div>
    );
};

const NewActivationScreen = ({ code, setStep, config, handleKeyDown }) => {
    const { isMultiStep, coBrandedLogo } = config;
    const qrLink = `${process.env.REACT_APP_REMOTE_CONTROL}pair/${code}`;

    return (
        <div className="activation">
            {isMultiStep && (
                <button tabIndex={-1} autoFocus onClick={() => setStep(1)} onKeyDown={(event) => handleKeyDown(event, 1)} className="back-button">
                    <img src={BackButton} alt="Back button" />
                </button>
            )}
            <div className="instructions">
                <div className="instruction-title">Activate Your Subscription</div>
            </div>
            <div className="possible-activations">
                <div className="qr-activation-container">
                    <div className="qr-activation-title">Pair device using a Phone or Tablet</div>
                    <div className="qr-activation-subtitle-section">
                        <div className={ScreenService.isVertical ? "qr-activation-subtitle-vertical" : "qr-activation-subtitle"}>Scan this QR code from your phone or tablet and login to start streaming content.</div>
                    </div>
                    <QRCodeSVG size={2000} value={qrLink} level="H" includeMargin={true} style={{ borderRadius: "2rem", height: "300px", width: "300px" }} />
                </div>
                <div className="separator"></div>
                <div className="activation-code-container">
                    <div className="code-title">Pair device using a Computer</div>
                    <div className="code-subtitle-section">
                        <div className={ScreenService.isVertical ? "code-subtitle-vertical" : "code-subtitle"}>
                            Go to <b>{process.env.REACT_APP_COMPUTER_PAIRING_MANAGER_LINK}</b> on your computer to link this device and start streaming.
                        </div>
                    </div>
                    <div className="code-content-container">
                        <div className={ScreenService.isVertical ? `code-title-contrast-vertical` : "code-title-contrast"}>Activation Code</div>
                        <div className={`${ScreenService.isVertical ? "vertical-code" : "code"} activation-code-content`}>{code}</div>
                    </div>
                </div>
            </div>
            <div className="contact">
                <SupportInfo everpassLogo={true} />
                <BrandInfo coBrandedLogo={coBrandedLogo} />
                <SalesInfo />
            </div>
            <button id="checks-button" className="hidden">
                <img src={GearButton} alt="Gear button" />
            </button>
        </div>
    );
};

const ActivationSteps = ({ onActivationComplete }) => {
    const activationConfig = getModelConfig().activationScreen;
    const { step, setStep, code } = useActivationFlow(onActivationComplete, activationConfig);

    const handleKeyDown = (event, targetStep) => {
        const { key } = event;
        if (key === "Enter") {
            setStep(targetStep);
        }
    };


    if (step === 1) {
        return <ActivationLanding setStep={setStep} config={activationConfig} handleKeyDown={handleKeyDown} />;
    }
    if (step === 2) {
        return <NewActivationScreen code={code} setStep={setStep} config={activationConfig} handleKeyDown={handleKeyDown} />;
    }

    return <></>;
};

export default ActivationSteps;
